/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailMessage
 */
export interface EmailMessage {
    /**
     * 
     * @type {string}
     * @memberof EmailMessage
     */
    to: string;
    /**
     * 
     * @type {string}
     * @memberof EmailMessage
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof EmailMessage
     */
    html: string;
}

export function EmailMessageFromJSON(json: any): EmailMessage {
    return EmailMessageFromJSONTyped(json, false);
}

export function EmailMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailMessage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'to': json['to'],
        'subject': json['subject'],
        'html': json['html'],
    };
}

export function EmailMessageToJSON(value?: EmailMessage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'to': value.to,
        'subject': value.subject,
        'html': value.html,
    };
}


